import api from '../services/api.js';

/**
 * downloadInboxZip — all "הודעות למערכת" recordings as one ZIP (GET /messages/inbox/download).
 *   onlyNew    only what was not downloaded yet
 *   memberId   only one member's messages
 *   onProgress (bytes) while the file arrives
 * Resolves to { fileCount }; rejects with the server's message.
 */
export async function downloadInboxZip({ onlyNew = false, memberId, onProgress } = {}) {
  let res;
  try {
    res = await api.get('/messages/inbox/download', {
      params: { ...(onlyNew ? { onlyNew: 1 } : {}), ...(memberId ? { memberId } : {}) },
      responseType: 'blob',
      timeout: 0,
      onDownloadProgress: (e) => onProgress?.(e.loaded || 0),
    });
  } catch (e) {
    // with responseType 'blob' the JSON error arrives as a Blob
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      let msg = '';
      try { msg = JSON.parse(await blob.text()).error || ''; } catch { /* not JSON */ }
      throw new Error(msg || 'שגיאה בהורדת ההקלטות');
    }
    throw new Error(e?.message || 'שגיאה בהורדת ההקלטות');
  }
  const cd = String(res.headers['content-disposition'] || '');
  const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
  const plain = cd.match(/filename="?([^";]+)"?/i);
  let filename = 'הודעות למערכת.zip';
  try { filename = decodeURIComponent((star || plain)?.[1] || '') || filename; } catch { /* keep default */ }

  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return { fileCount: Number(res.headers['x-file-count']) || 0 };
}

/**
 * downloadInboxMessage — one recording as a file (GET /messages/:id/download).
 * Rejects with the server's message.
 */
export async function downloadInboxMessage(id) {
  let res;
  try {
    res = await api.get(`/messages/${id}/download`, { responseType: 'blob', timeout: 0 });
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      let msg = '';
      try { msg = JSON.parse(await blob.text()).error || ''; } catch { /* not JSON */ }
      throw new Error(msg || 'שגיאה בהורדת ההקלטה');
    }
    throw new Error(e?.message || 'שגיאה בהורדת ההקלטה');
  }
  const star = String(res.headers['content-disposition'] || '').match(/filename\*=UTF-8''([^;]+)/i);
  let filename = 'הקלטה.wav';
  try { filename = decodeURIComponent(star?.[1] || '') || filename; } catch { /* keep default */ }

  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export const formatBytes = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)}MB` : `${Math.round(n / 1024)}KB`);
